(() => {
  if (document.documentElement.dataset.stMobileSearch === 'ready') return;
  document.documentElement.dataset.stMobileSearch = 'ready';

  const mobile = window.matchMedia('(max-width: 999px)');
  const activePanels = new WeakSet();
  const formSelector = 'form.st-mobile-search[data-search-dialog]';

  const openSearch = (form) => {
    if (!mobile.matches) return false;

    const sidebar = form.closest('header-sidebar');
    const panel = document.getElementById(form.dataset.searchDialog);
    const source = form.elements.q;
    const input = panel?.querySelector('input[name="q"]');

    if (!sidebar?.open || !input || typeof sidebar.hide !== 'function' || typeof panel.show !== 'function') return false;

    const start = source.selectionStart ?? source.value.length;
    const end = source.selectionEnd ?? source.value.length;
    const direction = source.selectionDirection ?? 'none';
    const menuButton = document.querySelector(`button[aria-controls="${CSS.escape(sidebar.id)}"]`);

    if (!activePanels.has(panel)) {
      const beforeHide = () => {
        panel.focusTrap.deactivate({ returnFocus: false, onDeactivate: () => {} });
      };
      const afterHide = () => {
        source.value = input.value;
        panel.removeEventListener('dialog:before-hide', beforeHide);
        panel.removeEventListener('dialog:after-hide', afterHide);
        activePanels.delete(panel);

        if (mobile.matches && menuButton?.getClientRects().length &&
            (panel.contains(document.activeElement) || document.activeElement === document.body || document.activeElement === source)) {
          menuButton.focus({ preventScroll: true });
        }
      };

      panel.addEventListener('dialog:before-hide', beforeHide);
      panel.addEventListener('dialog:after-hide', afterHide);
      activePanels.add(panel);
    }

    input.value = source.value;
    sidebar.focusTrap.deactivate({ returnFocus: false, onDeactivate: () => {} });
    sidebar.hide();
    panel.show(false);
    input.focus({ preventScroll: true });
    input.setSelectionRange(start, end, direction);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  };

  const onInput = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || event.isComposing) return;

    const form = input.closest(formSelector);
    if (form && input.name === 'q' && input.value.trim()) {
      openSearch(form);
      return;
    }

    const panel = input.closest('header-search');
    if (panel && input.name === 'q') {
      document.querySelectorAll(formSelector).forEach((mobileForm) => {
        if (mobileForm.dataset.searchDialog === panel.id) mobileForm.elements.q.value = input.value;
      });
    }
  };

  document.addEventListener('input', onInput);
  document.addEventListener('compositionend', onInput);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.matches(formSelector) && openSearch(form)) event.preventDefault();
  });
})();
